import { type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { FixedStickyContainerPortalComponent } from '../fixedStickyContainer/fixedStickyContainerPortal.component';
import { useLayeredPortalTarget } from './layeredPortal.context';

type LayeredPortalComponentProps = {
  children: ReactNode;
};

/**
 * Like `FixedStickyContainerPortalComponent`, but renders into the closest layer
 * (see `LayeredPortalHostComponent`) so it stacks together with that layer, e.g. above a modal.
 * Outside of any layer it falls back to the global fixed portal.
 */
export const LayeredPortalComponent = ({ children }: LayeredPortalComponentProps) => {
  const layerElement = useLayeredPortalTarget();

  if (!layerElement) {
    return <FixedStickyContainerPortalComponent>{children}</FixedStickyContainerPortalComponent>;
  }

  return createPortal(children, layerElement);
};
